import { render, staticRenderFns } from "./Movimiento.vue?vue&type=template&id=0f6ffd61"
import script from "./Movimiento.vue?vue&type=script&lang=js"
export * from "./Movimiento.vue?vue&type=script&lang=js"
import style0 from "./Movimiento.vue?vue&type=style&index=0&id=0f6ffd61&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports